import integrationsSlice from "../slices/integrationsSlice";

export const {
  RequestDeployInt,
  SuccessDeployInt,
  FailureDeployInt,
  RequestGetConfig,
  SuccessGetConfig,
  FailureGetConfig,
  RequestDeleteInt,
  SuccessDeleteInt,
  FailureDeleteInt,
  RequestSetConfig,
  SuccessSetConfig,
  FailureSetConfig,
  RequestResetConfig,
  SuccessResetConfig,
  FailureResetConfig,
  RequestTogglePhishboxLlm,
  SuccessTogglePhishboxLlm,
  FailureTogglePhishboxLlm,
  RequestCheckConfig,
  SuccessCheckConfig,
  FailureCheckConfig,
  ClearGetConfig,
  RequestDeleteConfig,
  SuccessDeleteConfig,
  FailureDeleteConfig,
  RequestUpdateConfig,
  SuccessUpdateConfig,
  FailureUpdateConfig,
  RequestAgentStatus,
  SuccessAgentStatus,
  FailureAgentStatus,
  RequestAgentInstallationList,
  SuccessAgentInstallationList,
  FailureAgentInstallationList,
  // RequestAllAgentsThreatHunter,
  // SuccessAllAgentsThreatHunter,
  // FaliureAllAgentsThreatHunter,
  RequestSingleAgentDataThunter,
  SuccessSingleAgentDataThunter,
  FaliureSingleAgentDataThunter,
  RequestSingleAgentIocResults,
  SuccessSingleAgentIocResults,
  FailureSingleAgentIocResults,
  RequestCreateNewAgent,
  SuccessCreateNewAgent,
  FailureCreateNewAgent,
  ResetCreateNewAgent,
  RequestAnalyzeAgent,
  SuccessAnalyzeAgent,
  FailureAnalyzeAgent,
  RequestYaraScanAgent,
  SuccessYaraScanAgent,
  FailureYaraScanAgent,
  RequestAgentAnalysisData,
  SuccessAgentAnalysisData,
  FailureAgentAnalysisData,
  RequestAgentSigmaOutput,
  SuccessAgentSigmaOutput,
  FailureAgentSigmaOutput,
  RequestAgentProcessSnapshot,
  SuccessAgentProcessSnapshot,
  FailureAgentProcessSnapshot,
  RequestUpdateAgentDescription,
  SuccessUpdateAgentDescription,
  FailureUpdateAgentDescription,
  RequestDeleteAgentRecord,
  SuccessDeleteAgentRecord,
  FailureDeleteAgentRecord,
  RequestAgentGroups,
  SuccessAgentGroups,
  FailureAgentGroups,
  RequestAllAgentGroups,
  SuccessAllAgentGroups,
  FailureAllAgentGroups,
  RequestBulkAnalyzeAgents,
  SuccessBulkAnalyzeAgents,
  FailureBulkAnalyzeAgents,
  RequestBulkYaraScanAgents,
  SuccessBulkYaraScanAgents,
  FailureBulkYaraScanAgents,
  RequestBulkDeleteAgents,
  SuccessBulkDeleteAgents,
  FailureBulkDeleteAgents,
  RequestCreateAgentGroup,
  SuccessCreateAgentGroup,
  FailureCreateAgentGroup,
  RequestDeleteAgentGroup,
  SuccessDeleteAgentGroup,
  FailureDeleteAgentGroup,
  RequestAgentPolicies,
  SuccessAgentPolicies,
  FailureAgentPolicies,
  RequestCreateAgentPolicy,
  SuccessCreateAgentPolicy,
  FailureCreateAgentPolicy,
  RequestAgentPolicy,
  SuccessAgentPolicy,
  FailureAgentPolicy,
  RequestMoveAgentPolicy,
  SuccessMoveAgentPolicy,
  FailureMoveAgentPolicy,
  RequestUpdateAgentPolicy,
  SuccessUpdateAgentPolicy,
  FailureUpdateAgentPolicy,
  RequestDeleteAgentPolicy,
  SuccessDeleteAgentPolicy,
  FailureDeleteAgentPolicy,
  RequestResetAgentPolicy,
  SuccessResetAgentPolicy,
  FailureResetAgentPolicy,
  RequestRepairAgentPolicy,
  SuccessRepairAgentPolicy,
  FailureRepairAgentPolicy,
  RequestDistinctLiveThreatHunters,
  SuccessDistinctLiveThreatHunters,
  FailureDistinctLiveThreatHunters,
  RequestTapInterfaces,
  SuccessTapInterfaces,
  FailureTapInterfaces,
  SetHunterBoxActiveTab,
  RequestHunterBoxList,
  SuccessHunterBoxList,
  FailureHunterBoxList,
  SetYaraResultsActiveTab,
  RequestYaraResultsList,
  SuccessYaraResultsList,
  FailureYaraResultsList,
  RequestHunterBoxStats,
  SuccessHunterBoxStats,
  FailureHunterBoxStats,
  RequestThreatHunterSubmit,
  SuccessThreatHunterSubmit,
  FailureThreatHunterSubmit,
  RequestGenerateAgentAIDecision,
  SuccessGenerateAgentAIDecision,
  FailureGenerateAgentAIDecision,
  RequestGetAgentAIDecision,
  SuccessGetAgentAIDecision,
  FailureGetAgentAIDecision,
  RequestAgentSandboxSubmit,
  SuccessAgentSandboxSubmit,
  FailureAgentSandboxSubmit,
  RequestDetectionSandboxTasks,
  SuccessDetectionSandboxTasks,
  FailureDetectionSandboxTasks,
  RequestAgentSandboxTasks,
  SuccessAgentSandboxTasks,
  FailureAgentSandboxTasks,
  RequestCancelAgentSandboxTask,
  SuccessCancelAgentSandboxTask,
  FailureCancelAgentSandboxTask,
  RequestThreatHunterDashboard,
  SuccessThreatHunterDashboard,
  FailureThreatHunterDashboard,
} = integrationsSlice.actions;
